export default "__VITE_ASSET__D5khCF_3__"